import { useQuery } from "@apollo/client";
import { FETCH_QC_REPORTS_LIST } from "../graphql";
import { InlineSpinner } from "components/base/Spinner";
import Errors from "components/base/Errors";
import { PAGE_SIZE } from ".";
import Button from "components/base/Button";
import QcReportListRow from "../components/QcReportListRow";

const ReportsListTableView = ({
  limit,
  offset,
  q,
  status,
  sourceType,
  recentRange,
  setOffset,
}) => {
  const { loading, error, data } = useQuery(FETCH_QC_REPORTS_LIST, {
    variables: { limit, offset, q, status, sourceType, recentRange },
  });

  if (loading)
    return (
      <div className="p-20 relative">
        <InlineSpinner />
      </div>
    );

  if (error) return <Errors error={error} />;

  return (
    <div className="card flex flex-col h-[85vh] overflow-hidden">
      <div className="flex-1 min-h-0 overflow-y-auto pr-6 [scrollbar-gutter:stable] divide-y divide-gray-100 dark:divide-gray-700">
        {data.qcReports.results.map((report) => (
          <QcReportListRow
            key={report.id}
            report={report}
            sourceType={sourceType}
          />
        ))}
      </div>

      <div className="py-3 flex justify-end items-center space-x-2 opacity-60 border-t shrink-0">
        {offset > 0 ? (
          <Button prev onClick={() => setOffset(offset - PAGE_SIZE)}></Button>
        ) : null}
        <div>
          {offset + 1}-{Math.min(PAGE_SIZE + offset, data.qcReports.total)} /{" "}
          {data.qcReports.total}
        </div>
        {data.qcReports.total > offset + PAGE_SIZE ? (
          <Button next onClick={() => setOffset(PAGE_SIZE + offset)}></Button>
        ) : null}
      </div>
    </div>
  );
};

export default ReportsListTableView;
